<template>
  <div class="volunteer-progress">
    <div class="content">
      <div class="progress">
        <div class="progress-item">
          <p class="text">提交申请</p>
        </div>
        <div class="progress-item">
          <p class="text">通知面试</p>
        </div>
        <div class="progress-item">
          <p class="text" style="color:#AEAEAE">提交成功</p>
        </div>
      </div>
      <img class="pic" :src="progressImg" alt srcset />
      <p class="cancel" v-touch:tap="cancelEntry">取消申请</p>
      <div class="des">
        <p class="h1">申请流程：</p>
        <p class="text">1、游客可通过线上申请成为志愿者。</p>
        <p class="text">2、申请成功后由馆方工作人员通知进行面试。</p>
        <p class="text">3、面试成功后方可成为志愿者。</p>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@js/http-zyz.js";
import { delApply, getProgressByOpenid } from "@js/volunteerUrl";
import progressImg from "@image/personalCenter/progress.png";
export default {
  name: "VolunteerProgress",
  data() {
    return { progressImg };
  },
  computed: {
    openId() {
      return this.$store.state.userInfo.openId;
    }
  },
  created() {
    http.post(getProgressByOpenid, { openId: this.openId }).then(res => {
      this.applyId = res.data.data.applyId;
    });
  },
  methods: {
    //取消志愿者申请
    cancelEntry() {
      this.$dialog
        .confirm({
          message: "是否确认取消申请志愿者?"
        })
        .then(() => {
          http
            .post(delApply, {
              openId: this.openId,
              applyId: this.applyId
            })
            .then(res => {
              if (res.data.success) {
                this.$dialog
                  .alert({
                    message: "已取消志愿者申请"
                  })
                  .then(() => {
                    this.$router.replace({ name: "personalCenter" });
                  });
              }
            });
        });
    }
  }
};
</script>
<style lang="less" scoped>
.volunteer-progress {
  padding: 16px 8px;
  background: #f1effb;
  .cancel {
    position: absolute;
    top: 32%;
    //     bottom: 30%;

    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 16px;
    color: #d8d8d8;
  }
  .content {
    position: relative;
    height: 486px;
    background: #ffffff;
    border-radius: 5px;

    .progress {
      position: absolute;
      top: 80px;
      left: 60px;
      transform: translateX(-30px);
      display: flex;
      justify-content: space-between;
      width: 80%;
      .cancel-btn{
        
      }
      &-item {
        width: 100px;
        height: 1px;
        background: #5e94ff;
        position: relative;

        .text {
          position: absolute;
          top: 16px;
          left: 50%;
          transform: translate(-50%, 0);
          font-size: 14px;
          color: #4282ff;
          white-space: nowrap;
        }

        &:first-child .text {
          left: ~"calc(50% - 20px)";
        }
        &:last-child .text {
          margin-left: 20px;
        }
        &:first-child {
          &::before,
          &::after {
            left: ~"calc(50% - 20px)";
          }
        }
        &:last-child {
          &::before,
          &::after {
            margin-left: 20px;
          }
          &::before {
            background: #d8d8d8;
          }
          background: #d8d8d8;
        }
        // position: absolute;

        &::before {
          content: " ";
          position: absolute;
          left: 50%;
          top: 0;
          transform: translate(-50%, -50%);
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background: #5e94ff;
          position: absolute;
          z-index: 2;
        }
        &::after {
          content: " ";
          position: absolute;
          left: 50%;
          top: 0;
          transform: translate(-50%, -50%);
          width: 16px;
          height: 16px;
          border-radius: 50%;
          border: 0.5px solid #5e94ff;
          background: #ffffff;
        }
      }
    }
    .pic {
      position: absolute;
      right: 10px;
      bottom: 20px;
      width: 120px;
      height: 110px;
    }
    .des {
      position: absolute;
      top: 50%;
      left: 20px;
      transform: translateY(-50%);
      font-size: 12px;
      color: #343434;
      .h1 {
        font-size: 14px;
        margin-bottom: 20px;
      }
      .text {
        margin-bottom: 14px;
      }
    }
  }
}
</style>